var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.tapsList.length
    ? _c(
        "div",
        {
          class: ["clarifications", { "_with-background": _vm.showBackground }],
        },
        [
          _vm.withTitle
            ? _c("h4", { staticClass: "title" }, [
                _vm._v("\n    Уточнить:\n  "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "clarifications-list",
              on: {
                scroll: function ($event) {
                  return _vm.scrollHandler($event)
                },
              },
            },
            _vm._l(_vm.tapsList, function (item, index) {
              return _c("button", {
                key: "clarification-" + index,
                staticClass: "clarification-item",
                domProps: { textContent: _vm._s(item.relatedSearch) },
                on: {
                  click: function ($event) {
                    return _vm.clarificationClickHandler(item)
                  },
                },
              })
            }),
            0
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }